import React, { PropsWithChildren } from 'react';

type Props = {
  onFinish: () => void;
  onCancel: () => void;
  finishButton: {
    message: React.ReactElement;
    isDisabled: boolean;
  };
  cancelButtonStr?: string;
  cancelButtonClassName?: string;
  imgPath?: string;
  imgOverStr?: string;
};

const useHeaderScrollView = () => {
  React.useEffect(() => {
    const element = document.getElementById('id_header');
    if (element !== null) element.scrollIntoView();
  }, []);
};

export const SetPropertiesBase = ({
  finishButton: { message: finishButtonMessage, isDisabled },
  cancelButtonStr,
  cancelButtonClassName,
  onFinish,
  onCancel,
  children,
  imgPath,
  imgOverStr,
}: PropsWithChildren<Props>): React.ReactElement => {
  useHeaderScrollView();
  return (
    <>
      <div className="p-4 flex flex-col bg-white">
        <div className="grid -mx-3 -mt-3">
          {imgPath && (
            <img
              src={imgPath}
              alt="目標イメージ"
              className="mb-4 w-full h-40"
              style={{ objectFit: 'cover', gridColumn: '1', gridRow: '1' }}
            />
          )}
          {imgOverStr && (
            <>
              <div
                className="bg-white z-10"
                style={{ gridColumn: '1', gridRow: '1', opacity: 0.45 }}></div>
              <div
                className="flex flex-row items-center justify-center font-bold text-bluegray-700 z-20 text-xl"
                style={{ gridColumn: '1', gridRow: '1' }}>
                {imgOverStr}
              </div>
            </>
          )}
        </div>
        {children}
        <button
          className={`mt-8 bg-tradewell rounded-lg shadow text-white py-2 text-center flex flex-row items-center gap-2 justify-center text-base ${
            isDisabled ? 'opacity-20' : ''
          }`}
          id="target_regist"
          onClick={onFinish}
          disabled={isDisabled}>
          {finishButtonMessage}
        </button>
        <button
          className={`mt-4 p-2 text-gray-700 text-center text-base ${cancelButtonClassName}`}
          onClick={onCancel}>
          {cancelButtonStr ?? 'キャンセル'}
        </button>
      </div>
    </>
  );
};
